window.addEventListener("load", function () {
    // lib bind MJ__toogleActive kèm `return false` (stopPropagation) nên click 2 nút này không tới platform
    $("#header .pm__login.MJ__toogleActive, #header .pm__logout.MJ__toogleActive")
        .removeClass("MJ__toogleActive")
        .off("click")
        .on("click", function (e) {
            if ($(this).attr("href") === "#") e.preventDefault();
        });
});
